import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { OidcSecurityService, PublicEventsService, EventTypes } from 'angular-auth-oidc-client';
import { ActivatedRoute, Router } from '@angular/router';
import { Encoder } from '../../utils/encoder';
import { redirectToNewZing, shouldRedirectToNewZing } from '../../utils/new-zing-redirect';
import { filter, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'z-callback',
  standalone: false,
  template: `
    <div class="starting d-flex flex-column justify-content-center align-items-center">
      <div class="m-3em d-flex align-items-center">
        <img src="/assets/icons/icon-logo-white.svg" height="120" alt="zing logo" />
      </div>
    </div>
  `,
  styles: [`
    @keyframes fadeInAndOut {
      0% {
        opacity: 0.05;
        transform: scale(1);
      }
      50% {
        opacity: 1;
        transform: scale(1.02);
      }
      100% {
        opacity: 0.05;
        transform: scale(1);
      }
    }

    .starting img {
      animation: fadeInAndOut 1.5s infinite;
    }
  `]
})
export class CallbackComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private eventService: PublicEventsService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit() {
    this.eventService
      .registerForEvents()
      .pipe(
        filter(
          (notification) =>
            notification.type === EventTypes.NewAuthenticationResult,
        ),
      )
      .subscribe((authorizationResult) => {
        if (authorizationResult.value.isAuthenticated) {
          // Capture synchronously before any async call can allow postLoginRoute
          // navigation to trigger MemberCanGuard.clearStorage() mid-flight.
          const redirectTo = sessionStorage.getItem("redirectTo");

          // Phase 4: every authenticated user is forced into New Zing, unless we stay
          // on classic. That happens either because there is no New Zing deployment to
          // hand off to (uat, training, where redirecting to '' would reload /callback in
          // a loop), or because an automated test set the force-classic cookie on a
          // lower environment.
          if (shouldRedirectToNewZing(this.document)) {
            redirectToNewZing(this.document, redirectTo ?? '');
            sessionStorage.setItem("redirectTo", "");
            localStorage.setItem("savedState", "");
          } else if (redirectTo) {
            // Staying on classic: honor the deep link the user or test asked for.
            // With no deep link we leave navigation to the OIDC client's postLoginRoute
            // rather than forcing a second full page load.
            location.href = environment.baseURL + redirectTo;
            sessionStorage.setItem("redirectTo", "");
            localStorage.setItem("savedState", "");
          }
        }
      });

    this.route.queryParams
      .subscribe(params => {
        const currentState = params['state'];
        const savedState = localStorage.getItem('savedState');
        // states don't match reset redirection url
        if (Encoder.decode(savedState) !== Encoder.decode(currentState)) {
          localStorage.setItem('redirectTo', '');
        }
        // if just the states don't match redirect to application
        // TODO: refactor this and handle it better, this is a Qick Fix
        this.oidcSecurityService.getState()
          .pipe(take(1), filter(res => res !== currentState))
          .subscribe(() => this.router.navigate(['/login']));
        this.oidcSecurityService.checkAuth(window.location.toString()).pipe(take(1)).subscribe();
      });
  }
}
